import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, DialogActions, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

import Hidden from './TzoHidden';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface PopupProps {
  open: boolean;
  setOpen: (val: boolean) => void;
}

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ComingSoonPopup = ({ open, setOpen }: PopupProps): React.JSX.Element => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className=""
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
      />
      <DialogContent>
        <Box component="div" sx={{ textAlign: 'center', mt: 2 }}>
          <picture>
            <source
              srcSet="/assets/images/coming-soon-img.webp"
              className="proportional-img"
              width={400}
              height={300}
            />
            <source
              srcSet="/assets/images/coming-soon-img.png"
              className="proportional-img"
              width={400}
              height={300}
            />
            <img
              src="/assets/images/coming-soon-img.png"
              loading="lazy"
              alt="E-file Form 7004, Form 4868 and Form 8868 with IRS securely"
              className="proportional-img"
              width={400}
              height={300}
            />
          </picture>
          <Typography
            gutterBottom
            variant="body1"
            sx={{
              fontWeight: 600,
              fontSize: { lg: 30, md: 26, sm: 22, xs: 18 },
              mb: 0,
            }}
          >
            TaxZerone will be accepting return e-filing shortly.
            <Hidden smDown>
              <br />
            </Hidden>
            Meanwhile, if you have any questions, please contact Us{' '}
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className="btn-primary"
              href="/contact-us/"
              sx={{
                mt: 2,
                mx: 'auto',
              }}
              // endIcon={<ArrowForwardIosIcon />}
            >
              Contact Us
            </Button>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          pb: '24px !important',
        }}
      />
    </BootstrapDialog>
  );
};

export default ComingSoonPopup;
